import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricMeetRate extends MetricBase {
    constructor() {
        super({
            field: "metric_meet_rate",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.meet_rate.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.meet_rate.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.meet_rate.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricMeetRate;